import { render, staticRenderFns } from "./NotificationsDrawer.vue?vue&type=template&id=477edfa2&scoped=true"
import script from "./NotificationsDrawer.vue?vue&type=script&lang=js"
export * from "./NotificationsDrawer.vue?vue&type=script&lang=js"
import style0 from "./NotificationsDrawer.vue?vue&type=style&index=0&id=477edfa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477edfa2",
  null
  
)

export default component.exports